interface PreviewVisualizerProps {
  playing: boolean;
  className: string;
}

function PreviewVisualizer({ playing, className }: PreviewVisualizerProps) {
  return (
    <span className={`${className} preview-visualizer ${playing ? 'playing' : ''}`} role="status" aria-label={playing ? 'Preview audio playing' : 'Preview audio ready'}>
      {[0, 1, 2, 3, 4].map((bar) => <i key={bar} />)}
    </span>
  );
}

export default PreviewVisualizer;
